import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import MultiAccessItem from './item'
import EditMultiAccessModal from './edit-modal'

import NumberFormatter from 'admin/utils/NumberFormatter';
import CheckboxLabel from 'common/components/elements/inputs/checkbox-label';
import toaster from "common/utils/toast";
import { toast } from 'react-toastify';
import cx from 'classnames';

// import { getCountState } from 'common/utils/utils'

const MultiAccess = ({
   contentType,
   membersMode,
   othersMode,
   membersAll,
   differentMembers,
   othersAll,
   differentOthers,
   handleAccsessChange,
   contentMetaInfo,
   membersStatistics,
   isMobile,
   sendToCancelled,
   onChangeActiveMemebrsAccess,
   sendToActive,
   showPrerelease,
   showDownload,
   videoType,
   discardModalState,
   showNewStyles,
   highestMembershipId,
   globalDisabled,
   globalDisabledTooltipText,
   isUnlockedDisabledForOthers,
   isUnlockedDisabledForOthersTooltipText,
   isDownloadDisabled,
   disabledDownloadTooltipText,
   isHomepage,
}) => {
   const numberFormatter = new NumberFormatter();
   const [maxPrice, setMaxPrice] = useState({ price: 100 })
   const [defaultNewAccess, setDefaultNewAccess] = useState({})
   const [cancelChackbox, setCancelChackbox] = useState(sendToCancelled)
   const [activeChackbox, setActiveChackbox] = useState(sendToActive)

   useEffect(() => {
      setCancelChackbox(sendToCancelled)
   }, [sendToCancelled])

   useEffect(() => {
      setActiveChackbox(sendToActive)
   }, [sendToActive])

   useEffect(() => {
      switch (contentType) {
         case 'video':
         case 'photoset':
         case 'store':
            updateMaxPriceForSites()
            break;
         case 'live_stream':
            setMaxPrice({ price: 100 });
            break;
         case 'chat':
            setMaxPrice({ price: 10 });
            break;

         default:
            break;
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [contentType])

   const updateMaxPriceForSites = () => {
      const price = contentMetaInfo?.content_unlock_max_price ? Number(contentMetaInfo.content_unlock_max_price) : 100;
      const minPrice = contentMetaInfo?.content_unlock_min_price
      const download = contentMetaInfo?.content_download_max_price ? Number(contentMetaInfo.content_download_max_price) : 100;
      setMaxPrice({ price,  download, minPrice });
      // if(!!isFriskyfairyk(appId)) {
      //    setMaxPrice({ price: 400,  download: 100  });
      // }
      // if(!!isKitehkawasaki(appId)) {
      //    setMaxPrice({ price: 250,  download: 100  });
      // }

   }

   const getValueState = (type) => {
      let res = {}
      switch (contentType) {
         case 'chat':
            res = getChatState()
            break;
         case 'video':
         case 'photoset':
            res = getMediaState(type)
            break;
         case 'custom_page':
            res = getCustomPagePageState(type)
            break;
         case 'mass_message':
         case 'promotions':
            res = getReceiveState()
            break;
         case 'live_stream':
            res = getLiveStreamState(type)
            break;
         case 'live_stream_chat':
            res = getLiveStreamChatState(type)
            break;
         case 'store':
            res = getStoreState(type)
            break
         case 'poll':
            res = getPollState(type)
            break
         default:
            break;
      }
      return res
   }

   const getStoreState = (type) => {
      let access = {
         // not_available: {
         //    icon: 'membership',
         //    text: 'Not available to this membership',
         //    color: 'secondary',
         //    description: '',
         //    hasChildren: true,
         // },
         locked: {
            icon: 'lock',
            text: 'Locked',
            hasChildren: true,
            color: 'warning',
            wthPrice: true,
         },
         hidden: {
            icon: 'unpublish',
            text: 'Hidden',
            color: 'secondary',
         },
      }
      // if('others' === type) {
      //    access = {
      //       ...access,
      //       // not_available: {
      //       //    icon: 'membership',
      //       //    text: 'Not available to others',
      //       //    color: 'secondary',
      //       //    hasChildren: true,
      //       // },
      //       locked: {
      //          icon: 'lock',
      //          text: 'Locked',
      //          color: 'warning',
      //          hasChildren: true,
      //          description: '',
      //          wthPrice: true,
      //       },
      //    }
      // }

      return access
   }

   const getChatState = () => {
      const access = {
         off: {
            icon: 'chat-mute',
            text: 'Cannot send private messages',
            color: 'secondary',
         },
         on: {
            icon: 'chat',
            text: 'FREE private messages',
            color: 'success',
            hasChildren: true,
         },
         payed: {
            icon: 'chat-unlock', //change icon chat-payed
            text: 'Pay-per-message',
            hasChildren: true,
            color: 'warning',
            // description: 'Members must pay a fee to send me messages',
         },
      }
      return access
   }

   const getMediaState = (type) => {
      let mediatext = 'view';
      if('video' === contentType) {
         mediatext = 'video' === videoType ? 'stream' : 'watch'
      }
      let access = {
         unlocked: {
            icon: 'play-default',
            text: 'Unlocked',
            color: 'success',
            hasChildren: true,
            description: 'members' === editModalOptions.memberType ? 'Included in membership' :  `Can ${ mediatext } for free`,
            disabled: isUnlockedDisabledForOthers && 'others' === type,
            disabledTooltipText: isUnlockedDisabledForOthers ? isUnlockedDisabledForOthersTooltipText : null,
         },
         locked: {
            icon: 'lock',
            text: 'Locked',
            hasChildren: true,
            color: 'warning',
            description: `Pay to ${ mediatext }`,
            wthPrice: true,
         },
         hidden: {
            icon: 'unpublish',
            text: 'Hidden',
            color: 'secondary',
         },
      }
      if('others' === type || (editModalOptions?.isOpen && 'members' === type && 'different' === editModalOptions.type) || !editModalOptions?.isOpen) {

         let notAvailableTitle = 'different' !== editModalOptions.type ? 'Not available to others' : 'Not available to';
         let notAvailableDescription = 'video' === contentType ? 'Full video for members only' : 'Photoset for members only';
         if('members' === type){
            notAvailableTitle = 'Not available for this membership';
            notAvailableDescription = '';
         }

         access = {
            not_available: {
               icon: 'play-filled-non',
               text: notAvailableTitle,
               color: 'secondary',
               hasChildren: true,
               description: notAvailableDescription,
            },
            ...access,
         }
      }
      return access
   }

   const getCustomPagePageState = (type) => {
      let access = {
         on: {
            icon: 'play-default',
            text: 'Can view',
            color: 'success',
            children: <span className='text-major text-xs text-leading-18 mt-1'>Included in membership</span>,
         },
         off: {
            icon: 'unpublish',
            text: 'Hidden',
            color: 'secondary',
            disabled: isHomepage,
            disabledTooltipText: 'This page cannot be hidden as it serves as your landing page',
         },

      }
      if('others' === type) {
         access = {
            ...access,
            not_available: {
               icon: 'play-filled-non',
               text: 'different' !== editModalOptions.type ? 'Not available to others' : 'Not available to',
               color: 'secondary',
            },
         }
      }
      return access
   }
   const getReceiveState = () => {
      const access = {
         receive: {
            icon: 'done',
            text: 'Will receive',
            color: 'success',
         },
         not_receive: {
            icon: 'block',
            text: 'Will not receive',
            color: 'secondary',
         },
      }
      return access
   }
   const getLiveStreamState = (type) => {
      let access = {
         unlocked: {
            icon: 'livestream',
            text: 'Unlocked',
            color: 'success',
            hasChildren: true,
            description: 'members' === editModalOptions.memberType ? 'Can watch' : 'Can watch',
         },
         locked: {
            icon: 'livestream-unlock',
            text: 'Locked',
            hasChildren: true,
            color: 'warning',
            description: 'Pay to watch',
            wthPrice: true,
         },
         hidden: {
            icon: 'others' === type ? 'unpublish' : 'livestream-blocked',
            text: 'others' === type ? 'Hidden' : 'Not available',
            color: 'secondary',
         },
      }
      if('others' === type || (editModalOptions?.isOpen && 'members' === type && 'different' === editModalOptions.type) || !editModalOptions?.isOpen) {

         let notAvailableTitle = 'different' !== editModalOptions.type ? 'Not available to others' : 'Not available to';
         let notAvailableDescription = 'Stream for members only';
         if('members' === type){
            notAvailableTitle = 'Not available for this membership';
            notAvailableDescription = '';
         }

         access = {
            not_available: {
               icon: 'livestream-blocked',
               text: notAvailableTitle,
               color: 'secondary',
               hasChildren: true,
               description: notAvailableDescription,
            },
            ...access,
         }
      }
      return access
   }
   const getLiveStreamChatState = () => {
      let access = {
         can_read_and_message: {
            icon: 'chat',
            text: 'Can read & message',
            color: 'success',
         },
         can_read_and_cannot_message: {
            icon: 'chat',
            text: 'Can read, cannot message',
            color: 'warning',
         },
         blurred_cannot_message: {
            icon: 'chat-mute',
            text: 'Blurred, cannot message',
            color: 'secondary',
         },
      }
      return access
   }

   const getPollState = (type) => {
      let access = {
         visible: {
            icon: 'views',
            text: 'Can vote',
            color: 'success',
         },
         hidden: {
            icon: 'no-views',
            text: 'Hidden',
            color: 'secondary',
         },
      }

      if('others' === type) {
         access = {
            not_available: {
               icon: 'membership',
               text: 'Can see but cannot vote',
               color: 'secondary',
            },
            ...access,
         }
      }

      return access
   }

   const [editModalOptions, setEditModalOptions] = useState({
      isOpen: false,
      type: null,
   })

   const getDefaultAccess = (isMember) => {
      let defaultAccess = {}
      switch (contentType) {
         case 'video':
         case 'photoset':
         case 'store':
            defaultAccess = {
               type: 'locked',
               unlock_price: 10,
               download_available_for_unlocked: false,
               download_is_free_for_unlocked: true,
               download_price_for_unlocked: 10,
               download_available_for_locked: false,
               download_is_free_for_locked: true,
               download_price_for_locked: 10,

               pre_release_available_for_locked: false,
               pre_release_price_for_locked: 10,
               pre_release_available_for_unlocked: false,
               pre_release_price_for_unlocked: 10,
            };

            if(isMember) {
               defaultAccess = {
                  ...defaultAccess,
                  cancelled_pay_more_to_unlock: false,
                  cancelled_pay_more_to_unlock_percentage: 20,
               };
            }
            break;
         case 'custom_page':
            defaultAccess = {
               type: 'on',
            }
            break;
         case 'chat':
            defaultAccess = {
               type: 'on',
               price_for_text_message: 0.05,
               free_text_messages_rules: {
                  mode: 'for_new_members',
                  number_of_free_messages: 0,
               },
               free_voice_messages_rules: {
                  mode: 'for_new_members',
                  number_of_free_messages: 0,
               },
               free_photo_messages_rules: {
                  mode: 'for_new_members',
                  number_of_free_messages: 0,
               },
               price_for_voice_message_for_payed: 0.05,
               available_voice_message_for_free: false,
               max_voice_message_duration_limit_for_payed: 600,
               max_voice_message_duration_limit_for_free: 600,
               available_voice_message_for_payed: false,
               price_for_photo_message_for_payed: 0.05,
               available_photo_message_for_free: false,
               available_photo_message_for_payed: false,
            }
            break;
         case 'mass_message':
         case 'promotions':
            defaultAccess = {
               type: 'receive',
            };
            break;
         case 'live_stream_chat':
            defaultAccess = {
               type: 'can_read_and_message',
            };
            break;
         case 'live_stream':
            defaultAccess = {
               type: 'locked',
               unlock_price: 10,
            };
            break;

         case 'poll':
            defaultAccess = {
               type: 'visible',
            };
            break;
         default:
            break;
      }
      return defaultAccess
   }

   const onAccsessChange = (value, mode, memberType) => {
      if(mode === 'different') {
         let state = 'members' === memberType ? differentMembers : differentOthers;
         if(!!state?.find(el => !el.access)) {
            let deff = {}
            state.forEach(element => {
               let accessData = element.access;
               let key = element.id || element.type;
               if(!element.access){
                  accessData = getDefaultAccess(!!element.id);
               }
               deff[key] = accessData
            });
            setDefaultNewAccess(deff)
            setEditModalOptions({ type: 'different', isOpen: true, memberType, state, initalDifferent: true })
            return
         }
      }
      handleAccsessChange({ [value]: mode })
   }

   const onOpenEditModal = (type, memberType) => {
      let state = null
      let initalDifferent = false
      if('all' === type) {
         state = 'members' === memberType ? membersAll : othersAll
         setDefaultNewAccess(state)
         if(!state) state = {}
      } else {
         state = 'members' === memberType ? differentMembers : differentOthers
         if(state) {
            initalDifferent = !!state.find(el => !el.access)
            let deff = {}
            state.forEach(element => {
               let key = element.id || element.type
               let accessData = element.access;
               if(!element.access) {
                  accessData = getDefaultAccess('members' === memberType)
               }
               deff[key] = accessData
            });
            setDefaultNewAccess(deff)
         }
         if(!state) state = []
      }
      setEditModalOptions({ type, isOpen: !!type, memberType, state, initalDifferent })
   }

   const getStatistics = data => {
      let state =  data || membersStatistics
      if('mass_message' === contentType && !data){
         state = getStatisticsState();
      }
      const {
         active_members_count,
         expired_members_count,
         guest_members_count,
         cancelled_members_count,
         free_members_count,
      } = state;
      let activeMemberCount = 'active_members_count' in state ?  numberFormatter.withCommas(active_members_count) : null;
      const expiredMemberCount = 'expired_members_count' in state ? numberFormatter.withCommas(expired_members_count) : null;
      const guestMemberCount = 'guest_members_count' in state ? numberFormatter.withCommas(guest_members_count) : null;
      let cancelledMemberCount = 'cancelled_members_count' in state ? numberFormatter.withCommas(cancelled_members_count) : null;
      const subscribedMemberCount = 'mailing_list_count' in membersStatistics ? numberFormatter.withCommas(membersStatistics.mailing_list_count) : null;
      let freeMemberCount = 'free_members_count' in state ? numberFormatter.withCommas(free_members_count) : null;
      if('mass_message' === contentType && !cancelChackbox) {
         cancelledMemberCount = null;
      }
      if('mass_message' === contentType && !activeChackbox) {
         activeMemberCount = null;
         freeMemberCount = null
      }
      return {
         activeMemberCount,
         expiredMemberCount,
         guestMemberCount,
         cancelledMemberCount,
         freeMemberCount,
         subscribedMemberCount,
      }
   }
   const getStatisticsState = _ => {
      let state = {
         active_members_count: membersStatistics?.active_members_count || 0,
         cancelled_members_count: membersStatistics?.cancelled_members_count || 0,
         free_members_count: membersStatistics?.free_members_count || 0,
         expired_members_count: membersStatistics?.expired_members_count || 0,
         guest_members_count: membersStatistics?.guest_members_count || 0,
      }
      let differentAccess = [];
      if('different' === membersMode){
         differentAccess = [...differentAccess, ...differentMembers];
         state = {
            ...state,
            active_members_count: 0,
            cancelled_members_count: 0,
            free_members_count: 0,
         }
      }
      if('different' === othersMode){
         differentAccess = [...differentAccess, ...differentOthers];
         state = {
            ...state,
            guest_members_count: 0,
            expired_members_count: 0,
         }

      }
      if(differentAccess.length > 0){
         for(const key in differentAccess) {
            if(Object.hasOwnProperty.call(differentAccess, key)) {
               const element = differentAccess[key];
               if(element?.access?.type === 'receive'){
                  switch (element?.type) {
                     case 'free':{
                        state.free_members_count = state.free_members_count + element.active_members_count;
                        break;
                     }
                     case 'guest': {
                        state.guest_members_count = state.guest_members_count + element.guest_members_count;
                        break;
                     }

                     case 'expired': {
                        state.expired_members_count = state.expired_members_count + element.expired_members_count;
                        break;
                     }
                     default: {
                        state.active_members_count = state.active_members_count + element.active_members_count;
                        state.cancelled_members_count = state.cancelled_members_count + element.cancelled_members_count;
                        break;
                     }
                  }

               }
            }
         }
      }
      return state;
   }

   const getModalHeaderText = () => {

      let settings = {
         textStyles: 'text-secondary mt-1 whitespace-normal text-center max-[700px]:!px-4 px-6',
         modalTitle: 'Chat access settings',
      }

      if(contentType === 'store') {
         settings.modalTitle = 'Bundle access settings'
      }

      if(!['chat', 'store', 'mass_message'].includes(contentType)) {
         settings.modalTitle = 'Content access settings'
      }

      if(['live_stream'].includes(contentType)) {
         settings.modalTitle = 'Stream access settings'
      }
      else if(['live_stream_chat'].includes(contentType)) {
         settings.modalTitle = 'Chat access settings'
      }

      if("mass_message" === contentType) {
         settings.modalTitle = 'Access settings'
      }

      if("poll" === contentType) {
         settings.modalTitle = 'Access'
      }

      if(editModalOptions?.memberType === 'members') {
         if(editModalOptions?.type === 'all') {
            return {
               ...settings,
               headerText: 'These settings will be applied to all memberships',
               type: 'all',
            }
         }
         return {
            ...settings,
            headerText: 'Each membership will have different settings',
            type: 'different',
         }
      }
      if(editModalOptions?.type === 'all') {
         return {
            ...settings,
            headerText: 'These settings will be applied to all non-members (“Others”)',
            type: 'all',
         }
      }
      return {
         ...settings,
         headerText: 'Each non-member type will have different settings',
         type: 'different',
      }

   }

   const disabledMassMessageCheckboxs = () => {
      if('all' === membersMode) {
         return 'not_receive' === membersAll.type;
      }
      if('different' === membersMode) {
         const hasReceiveGroup = differentMembers.find(el => 'receive' === el?.access?.type);
         if(!hasReceiveGroup){
            return true;
         }
         return false;
      }
      return false;
   }

   return (
      <>
         <MultiAccessItem
            type='active'
            openEditModal={ (type) => onOpenEditModal(type, 'members') }
            moreState={ getValueState('members') }
            mode={ membersMode }
            different={ differentMembers }
            all={ membersAll }
            onChangeAccessMode={ (mode) => onAccsessChange('access_for_members_mode', mode, 'members') }
            contentType={ contentType }
            statistics={ getStatistics() }
            isMobile={ isMobile }
            // cancelChackbox={ cancelChackbox }
            showPrerelease={ showPrerelease }
            showDownload={ showDownload }
            videoType={ videoType }
            showNewStyles={ showNewStyles }
            globalDisabled={ globalDisabled }
            globalDisabledTooltipText={ globalDisabledTooltipText }
         />
         {
            'mass_message' === contentType && (
               <>
                  <div
                     className={ cx({
                        'h-6 mt-4': true,
                        ' opacity-50': disabledMassMessageCheckboxs(),
                     }) }
                  >
                     <CheckboxLabel
                        checkboxSize='4'
                        label='Send to active members'
                        onChange={ (name, value) => {
                           if(!cancelChackbox && !value){
                              if(!toast.isActive('at_least_one_option_selected')){
                                 toaster.error('At least one option must be selected',  { toastId: 'at_least_one_option_selected' })
                              }
                              return
                           }
                           setActiveChackbox(value)
                           onChangeActiveMemebrsAccess('send_to_active_members', value)
                        } }
                        checked={ activeChackbox }
                        name='send_to_active_members'
                        textSize='sm'
                        lineHeight='20px'
                        textColor='major'
                        padding='none'
                        disabled={ disabledMassMessageCheckboxs() }
                     />
                  </div>
                  <div
                     className={ cx({
                        'h-6 mt-4': true,
                        ' opacity-50': disabledMassMessageCheckboxs(),
                     }) }
                  >
                     <CheckboxLabel
                        checkboxSize='4'
                        label='Send to canceled members'
                        onChange={ (name, value) => {
                           if(!activeChackbox && !value){
                              if(!toast.isActive('at_least_one_option_selected')){
                                 toaster.error('At least one option must be selected',  { toastId: 'at_least_one_option_selected' })
                              }
                              return
                           }
                           setCancelChackbox(value)
                           onChangeActiveMemebrsAccess('send_to_cancelled_members', value)
                        } }
                        checked={ cancelChackbox }
                        name='send_to_cancelled_members'
                        textSize='sm'
                        lineHeight='20px'
                        textColor='major'
                        padding='none'
                        disabled={ disabledMassMessageCheckboxs() }
                     />
                  </div>
               </>
            )
         }
         <MultiAccessItem
            type='public'
            className='mt-4'
            openEditModal={ (type) => onOpenEditModal(type, 'others') }
            moreState={ getValueState('others') }
            mode={ othersMode }
            different={ differentOthers }
            all={ othersAll }
            onChangeAccessMode={ (mode) => onAccsessChange('access_for_others_mode', mode, 'others') }
            contentType={ contentType }
            statistics={ getStatistics() }
            isMobile={ isMobile }
            showPrerelease={ showPrerelease }
            showDownload={ showDownload }
            videoType={ videoType }
            showNewStyles={ showNewStyles }
            globalDisabled={ globalDisabled }
            globalDisabledTooltipText={ globalDisabledTooltipText }
         />
         {
            editModalOptions.isOpen && (
               <EditMultiAccessModal
                  onCloseModal={ () => onOpenEditModal(null, null) }
                  title={  editModalOptions.memberType.charAt(0).toUpperCase() + editModalOptions.memberType.slice(1) }
                  memberType={ editModalOptions.memberType }
                  isDiferent={ 'different' === editModalOptions.type }
                  data={ editModalOptions.state }
                  state={ getValueState(editModalOptions.memberType) }
                  onChangeAccess={ (data, callBack) => {
                     let key = `access_${ editModalOptions.memberType }_${ editModalOptions.type }`
                     let updateData = { [key]: data }
                     updateData = {
                        ...updateData,
                        [`access_for_${ editModalOptions.memberType }_mode`]: editModalOptions.type,
                     }
                     handleAccsessChange(updateData, () => {
                        if(callBack){
                           callBack()
                        }
                        onOpenEditModal(null, null)
                     })
                  } }
                  maxPrice={ maxPrice }
                  defaultNewAccess={ defaultNewAccess }
                  initialAccess={ getDefaultAccess('members' === editModalOptions.memberType) }
                  contentType={ contentType }
                  statistics={ (data) => getStatistics(data) }
                  getStatistics={ (data) => getStatistics(data) }
                  isActiveMember={ 'members' === editModalOptions.memberType }
                  initalDifferent={ editModalOptions.initalDifferent }
                  isMobile={ isMobile }
                  // cancelChackbox={ cancelChackbox }
                  showPrerelease={ showPrerelease }
                  showDownload={ showDownload }
                  discardModalState={ discardModalState }
                  showNewStyles={ showNewStyles }
                  modalheaderText={ getModalHeaderText() }
                  highestMembershipId={ highestMembershipId }
                  isDownloadDisabled={ isDownloadDisabled }
                  disabledDownloadTooltipText={ disabledDownloadTooltipText }
               />
            )
         }
      </>
   )
}

const ChatMessageState = ({ data }) => {

   const getFreeMode = (mode) => {
      if(!mode){
         return  'sign up';
      }

      let result = ''
      switch (mode) {
         case 'for_new_members':{
            result =  'newly joined';
            break;
         }
         case 'for_all_members_every_30_days':{
            result =  'every 30 days';
            break;
         }
         default:
            break;
      }
      return result;
   }

   return (
      <>
         {
            'payed' === data?.type && (
               <span className='text-major text-xs text-leading-18 mt-1'>Members must pay a fee to send me messages</span>
            )
         }
         <div className='text-xs flex flex-col mt-2 text-secondary'>
            {
               'payed' === data?.type && (
                  <>
                     {
                        (data.price_for_text_message || 'number' === typeof data.price_for_text_message) && (
                           <ChatMessageStateItem
                              label='Text message:'
                              value={ data.price_for_text_message ?  `${ data.price_for_text_message } USD` : 'Free' }
                           />
                        )
                     }
                     {
                        Boolean(data?.free_text_messages_rules?.number_of_free_messages) && (
                           <ChatMessageStateItem
                              label={ `${ data.free_text_messages_rules?.number_of_free_messages } free messages` }
                              value={ ` for ${ getFreeMode(data.free_text_messages_rules?.mode) } ` }
                           />
                        )
                     }
                     {
                        data.price_for_photo_message_for_payed && (
                           <>
                              <br />
                              <ChatMessageStateItem
                                 label='Image:'
                                 value={ data.available_photo_message_for_payed ? `${ data.price_for_photo_message_for_payed } USD` : "OFF" }
                              />
                           </>
                        )
                     }
                     {
                        Boolean(data?.free_photo_messages_rules?.number_of_free_messages) && (
                           <ChatMessageStateItem
                              label={ `${ data.free_photo_messages_rules?.number_of_free_messages } free messages` }
                              value={ ` for ${ getFreeMode(data.free_photo_messages_rules?.mode) } ` }
                           />
                        )
                     }
                     {
                        data.price_for_voice_message_for_payed && (
                           <>
                              <br />
                              <ChatMessageStateItem
                                 label='Voice message:'
                                 value={ data.available_voice_message_for_payed ? `${ data.price_for_voice_message_for_payed } USD, (max ${ data.max_voice_message_duration_limit_for_payed } sec)` : "OFF" }
                              />
                           </>
                        )
                     }
                     {
                        Boolean(data?.free_voice_messages_rules?.number_of_free_messages) && (
                           <ChatMessageStateItem
                              label={ `${ data.free_voice_messages_rules?.number_of_free_messages } free messages` }
                              value={ ` for ${ getFreeMode(data.free_voice_messages_rules?.mode) } ` }
                           />
                        )
                     }
                  </>
               )
            }
            {
               'on' === data?.type && (
                  <>
                     <ChatMessageStateItem
                        label='Image:'
                        value={ data.available_photo_message_for_free ? 'ON' : 'OFF' }
                     />
                     <ChatMessageStateItem
                        label='Voice message:'
                        value={ data.available_voice_message_for_free ? `ON (max ${ data.max_voice_message_duration_limit_for_free } sec)` : 'OFF' }
                     />
                  </>
               )
            }

         </div>
      </>
   )
}

const ChatMessageStateItem = ({
   label,
   value,
}) => {
   return (
      <span className='text-xs leading-[18px]'>
         <span className='font-bold'>{label}</span> {value}
      </span>
   )
}
const IncludActiveMembersText = ({ activeMemberCount, cancelledMemberCount, freeMemberCount, showNewStyles }) => {
   return (
      <span className='panel-description text-secondary select-none'>Includes
         {
            activeMemberCount && (
               <>
                &nbsp;
                  {activeMemberCount} <span className='font-bold'> active{cancelledMemberCount && ','}</span>
               </>
            )
         }
         {
            cancelledMemberCount && (
               <>
               &nbsp;
                  {cancelledMemberCount} <span className='font-bold'> cancelled{freeMemberCount && ','}</span>
               </>
            )
         }
         {
            freeMemberCount && (
               <>
                &nbsp;and {freeMemberCount} <span className='font-bold'> complimentary</span> {showNewStyles ? 'members' : ''}
               </>
            )
         }
      </span>
   )
}

const IncludInActiveMembersText = ({ expiredMemberCount, guestMemberCount, subscribedMemberCount, isVisitor = true }) => {
   return (
      <span className='panel-description text-secondary dark:text-secondary-dark select-none'>Includes {expiredMemberCount} <span className='font-bold'>expired,&nbsp;</span>
         {guestMemberCount} <span className='font-bold'> guests
            {
               isVisitor && (
                  <>
                     , <span className='font-normal'>and</span> <span className='font-bold'>visitors</span>
                  </>
               )
            }
         </span>
         {
            !isVisitor &&  subscribedMemberCount && (
               <>
                  ,&nbsp;{subscribedMemberCount} <span className='font-bold'>subscribers</span>
               </>
            )
         }
      </span>
   )
}

MultiAccess.propTypes = {
   contentType: PropTypes.oneOf(['chat', 'video', 'photoset', 'custom_page', 'mass_message', 'promotions', 'live_stream', 'live_stream_chat', 'store', 'poll']),
   videoType: PropTypes.oneOf(['livestream', 'video']),
   membersMode: PropTypes.string,
   othersMode: PropTypes.string,
   membersAll: PropTypes.object,
   differentMembers: PropTypes.array,
   othersAll: PropTypes.object,
   differentOthers: PropTypes.array,
   handleAccsessChange: PropTypes.func,
   contentMetaInfo: PropTypes.object,
   membersStatistics: PropTypes.object,
   isMobile: PropTypes.bool,
   onChangeActiveMemebrsAccess: PropTypes.func,
   sendToCancelled: PropTypes.bool,
   sendToActive: PropTypes.bool,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   discardModalState: PropTypes.object,
   showNewStyles: PropTypes.bool,
   highestMembershipId: PropTypes.number,
   globalDisabled: PropTypes.bool,
   globalDisabledTooltipText: PropTypes.string,
   isUnlockedDisabledForOthers: PropTypes.bool,
   isUnlockedDisabledForOthersTooltipText: PropTypes.string,
   isDownloadDisabled: PropTypes.bool,
   isHomepage: PropTypes.bool,
   disabledDownloadTooltipText: PropTypes.string,
}

ChatMessageState.propTypes = {
   data: PropTypes.object,
};

IncludInActiveMembersText.propTypes = {
   expiredMemberCount: PropTypes.any,
   guestMemberCount: PropTypes.any,
   subscribedMemberCount: PropTypes.any,
   isVisitor: PropTypes.bool,
};

IncludActiveMembersText.propTypes = {
   showNewStyles: PropTypes.bool,
   activeMemberCount: PropTypes.any,
   cancelledMemberCount: PropTypes.any,
   freeMemberCount: PropTypes.any,
};

MultiAccess.defaultProps = {
   contentType: 'video',
   videoType: 'video',
   showDownload: true,
   discardModalState: {},
   showNewStyles: false,
};
ChatMessageStateItem.propTypes = {
   label: PropTypes.string,
   value: PropTypes.any,
};

export default MultiAccess
export { ChatMessageState, IncludActiveMembersText, IncludInActiveMembersText }
